import React, { Component } from 'react';

export default function withScrollSpy(headerHeight = 0) {
  return WrappedComponent =>
    class ScrollSpyComponent extends Component {
      visibleElements = [];

      elements = [];

      state = {
        intersectingElement: null
      };

      constructor(...args) {
        super(...args);
        this.observer = new window.IntersectionObserver(
          this.handleIntersection,
          {
            rootMargin: `-${headerHeight}px 0px 0px 0px`,
            // fires when element enters and leaves viewport
            threshold: [0, 1]
          }
        );
      }

      setElement = (idx, el) => {
        if (el) {
          this.elements[idx] = el;
          this.observer.observe(el);
        } else {
          this.elements[idx] = null;
        }
      };

      handleIntersection = entries => {
        entries.forEach(entry => {
          // element entered viewport
          if (entry.isIntersecting) {
            if (entry.boundingClientRect.y > 0) {
              // element entered from below; user is scrolling down
              this.visibleElements.unshift(entry.target);
            } else {
              this.visibleElements.push(entry.target);
            }
          } else {
            this.visibleElements = this.visibleElements.filter(
              el => el !== entry.target
            );
          }
        });

        if (this.visibleElements[0] !== this.state.intersectingElement) {
          this.setState({ intersectingElement: this.visibleElements[0] });
        }
      };

      componentWillUnmount() {
        this.observer.disconnect();
      }

      render() {
        return (
          <WrappedComponent
            {...this.props}
            intersectingElement={this.state.intersectingElement}
            intersectingElements={this.elements}
            setIntersectingElement={this.setElement}
          />
        );
      }
    };
}
